import { Routes } from '@angular/router';
import { Landing } from './pages/landing/landing';
import { Dashboard } from './pages/dashboard/dashboard';
import { Login } from './pages/login/login';
import { Signup } from './pages/signup/signup';
import { ForgotPassword } from './pages/forgot-password/forgot-password';
import { ResetPassword } from './pages/reset-password/reset-password';
import { BoardEditor } from './pages/board-editor/board-editor';
import { Profile } from './pages/profile/profile';
import { BoardDisplay } from './pages/board-display/board-display';
import { Demo } from './pages/demo/demo';
import { PrivacyPolicy } from './pages/privacy-policy/privacy-policy';
import { TermsOfService } from './pages/terms-of-service/terms-of-service';
import { authGuard } from './guards/auth.guard';
import { guestGuard } from './guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    component: Landing,
    title: 'FlippyBoards.com -- Home',
    canActivate: [guestGuard],
  },
  {
    path: 'login',
    component: Login,
    title: 'FlippyBoards.com -- Log In',
    canActivate: [guestGuard],
  },
  {
    path: 'signup',
    component: Signup,
    title: 'FlippyBoards.com -- Sign Up',
    canActivate: [guestGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPassword,
    title: 'FlippyBoards.com -- Forgot Password',
    canActivate: [guestGuard],
  },
  {
    // No guestGuard: the emailed reset link must work even if this browser
    // already has a session (e.g. reset requested from another device).
    path: 'reset-password',
    component: ResetPassword,
    title: 'FlippyBoards.com -- Reset Password',
  },
  {
    path: 'privacy',
    component: PrivacyPolicy,
    title: 'FlippyBoards.com -- Privacy Policy',
  },
  {
    path: 'terms',
    component: TermsOfService,
    title: 'FlippyBoards.com -- Terms of Service',
  },
  {
    path: 'demo',
    component: Demo,
    title: 'FlippyBoards.com -- Demo',
  },
  {
    path: 'display/:id',
    component: BoardDisplay,
    title: 'FlippyBoards.com -- Board Display',
  },
  {
    path: 'dashboard',
    component: Dashboard,
    title: 'FlippyBoards.com -- My Boards',
    canActivate: [authGuard],
  },
  {
    path: 'profile',
    component: Profile,
    title: 'FlippyBoards.com -- My Profile',
    canActivate: [authGuard],
  },
  {
    path: 'boards/new',
    component: BoardEditor,
    title: 'FlippyBoards.com -- Create Board',
    canActivate: [authGuard],
  },
  {
    path: 'boards/:id/edit',
    component: BoardEditor,
    title: 'FlippyBoards.com -- Edit Board',
    canActivate: [authGuard],
  },
];
